let $subscriptionModal;

const OPEN_CLASS = 'is-open';
const LOADING_CLASS = 'is-loading';
const ERROR_CLASS = 'is-error';
const SUCCESS_CLASS = 'is-success';

$(document).ready(function ($) {
    $subscriptionModal = $('.js-subscription-modal');

    initModalButton();
    initSubscriptionForm();
});

function initModalButton() {
    $('.js-subscribe').on('click', function () {
        $subscriptionModal.addClass(OPEN_CLASS);
    });
}

function initSubscriptionForm() {
    $('.js-save-subscription-form').on('submit', function (event) {
        event.preventDefault();

        let $subscriptionFormContainer = $(this).closest('.js-subscription-form-container');
        let $subscriptionMessage = $('.js-subscription-message');
        saveSubscription($subscriptionFormContainer, $subscriptionMessage);
    });
}

function saveSubscription($subscriptionFormContainer, $subscriptionMessage) {
    $subscriptionFormContainer.addClass(LOADING_CLASS);
    $subscriptionFormContainer.removeClass(ERROR_CLASS);
    $subscriptionFormContainer.removeClass(SUCCESS_CLASS);

    $.ajax({
        url: linku_ajax_url,
        type: 'post',
        data: {
            action: 'aboland_save_subscription',
            zipCode: $('#subscription-zipcode').val(),
            subscription: $('#subscription-code').val(),
            nonce: aboland.nonce
        },
        dataType: 'json',
        success: function () {
            $subscriptionFormContainer.removeClass(LOADING_CLASS);
            $subscriptionFormContainer.addClass(SUCCESS_CLASS);
            $subscriptionMessage.text('Gelukt! Dit venster sluit vanzelf na 3 seconden.');
            setTimeout(closeSubscriptionModal,3000);
            },
        error: function () {
            $subscriptionFormContainer.removeClass(LOADING_CLASS);
            $subscriptionFormContainer.addClass(ERROR_CLASS);
            $subscriptionMessage.text('Er is iets mis gegaan, de code lijkt niet te kloppen');
        }
    });
}

function closeSubscriptionModal() {
    $subscriptionModal.removeClass(OPEN_CLASS);
}
